<template>
  <CartPaymentButton
    :isReturnAndExchangeItemInCart="isReturnAndExchangeItemInCart"
    :isLoading="isLoading"
    :isUnderMinimumOrderPrice="isUnderMinimumOrderPrice"
    :totalQuantity="totalQuantity"
    :totalPrice="totalPrice"
    :onPayment="isReturnAndExchangeItemInCart ? doReturnOrExchange : onPaymentButton"
  />
</template>

<script>
import CartPaymentButton from '@/presentationals/v2/components/layouts/organisms/CartPaymentButton'
import { Location, MoveType } from '@/plugins/AppManager'
import { isLocalhost } from '@/utils/dev'
import { isProvideImmediateDiscount } from '../../../../../config/featureProvider'
import { Action } from '../../../../../plugins/AppManager'
import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'CartPaymentButtonContainer',
  components: {
    CartPaymentButton
  },
  computed: {
    isUnderMinimumOrderPrice() {
      return this.$store.getters['cart/totalPrice'] < this.$store.getters['cart/minimumOrderPrice']
    },
    isReturnAndExchangeItemInCart() {
      return this.$store.getters['cart/isReturnAndExchangeItemInCart']
    },
    totalQuantity() {
      return this.$store.getters['cart/totalQuantity']
    },
    totalPrice() {
      if (this.$store.getters['cart/isReturnAndExchangeItemInCart'])
        return this.$store.getters['cart/totalPrice']

      const nowPrice = this.$store.getters['cart/totalPrice']
      const nowDiscount = this.$store.getters['cart/nowCartDiscount'](nowPrice)
      const nowDeliveryCharge = this.$store.getters['cart/nowCartDeliveryCharge'](nowPrice)
      // const nowDeliveryCharge = this.$store.getters['cart/cartDeliveryCharges'][0]
      const defaultDeliveryCharge = this.$store.getters['cart/defaultDeliveryCharge']

      const { appVersion, isAndroid } = this.$store.getters
      const provideImmediateDiscount = isProvideImmediateDiscount({ appVersion, isAndroid })

      const immediateSalePrice = provideImmediateDiscount
        ? !nowDiscount
          ? 0
          : nowDiscount.discountAmount
        : 0

      const deliveryChargePrice = !nowDeliveryCharge
        ? 0
        : defaultDeliveryCharge - nowDeliveryCharge.discountDeliveryCharge

      // return this.$store.getters['cart/totalPrice'] - immediateSalePrice + deliveryChargePrice
      return this.$store.getters['cart/totalPrice'] + deliveryChargePrice
    }
  },
  methods: {
    doPaymentLog() {
      const params = {
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M1-7
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_CART,
        type: LogType.CLICK,
        group: LogGroup.CART_DET,
        event: LogEvent.ORD,
        params
      })
    },

    /**
     * @returns {boolean} true: 실패, false: 성공
     */
    async doValidate() {
      const validate = await this.$store.dispatch(
        'cart/validateEqualPriceOperationPolicyToBeforePayment'
      )

      // API 응답 에러인 경우
      if (validate === null) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: '주문 중 문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
          onOK: async () => {
            this.$store.dispatch('modal/close')
            await this.$store.dispatch('cart/load')
          }
        })
        return true
      }

      // validator error message 로 반환된 경우
      if (typeof validate === 'string') {
        // true 면 맞지 않음
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: validate,
          onOK: async () => {
            this.$store.dispatch('modal/close')
            await this.$store.dispatch('cart/load')
          },
          onCancel: async () => {}
        })
        return true
      }

      return false
    },

    async doPayment() {
      if (this.isLoading) return

      this.isLoading = true

      const result = await this.$store.dispatch(
        'cart/paymentToCartProducts',
        this.$store.getters['cart/checkedCartProducts']
      )

      if (result.code === '401') {
        this.$store.dispatch('modal/open', {
          // Modal Open
          type: 'Check',
          message: result.message,
          onOK: async () => {
            this.$store.dispatch('modal/close')
            this.$appManager.action(Action.REFRESH_TOKEN) // Refresh Token 요청
            setTimeout(() => {
              this.$appManager.action(Action.CLOSE)
            }, 150)
          },
          onCancel: async () => {}
        })

        this.isLoading = false
        return
      }

      if (!result.success) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: result.message,
          onOK: async () => {
            this.$store.dispatch('modal/close')
            this.$appManager.action(Action.CLOSE)
          },
          onCancel: async () => {}
        })

        this.isLoading = false
        return
      }

      this.doPaymentLog()

      const { orderSheetUrl } = result.result
      if (isLocalhost()) {
        const target = orderSheetUrl.includes('https://market-api-v2.dev.woowa.in')
          ? 'https://market-api-v2.dev.woowa.in'
          : 'https://market-api-v2.beta.baemin.com'

        this.$appManager.moveSimple(
          orderSheetUrl.replace(target, 'http://localhost:9002'),
          MoveType.PUSH
        )
      } else {
        this.$appManager.move(Location.ORDER_SHEET, this.$store.getters.isAndroid, MoveType.PUSH, {
          marketOrder_url: orderSheetUrl
        })
      }

      const timeout = window.setTimeout(() => {
        this.isLoading = false
        window.clearTimeout(timeout)
      }, 1000)
    },

    async onPaymentButton() {
      if (this.isUnderMinimumOrderPrice) return

      const validate = await this.doValidate()
      if (validate) return

      await this.doPayment()
    },

    async doReturnOrExchange() {
      await this.doPayment()
    }
  },
  data() {
    return {
      isLoading: false
    }
  }
}
</script>
